<template>
  <div class="container_PProgress">
    <div class="textProgress_PProgress">{{ porcentage }} %</div>
    <div class="progress_PProgress" :style="'width:' + porcentage + '%'"></div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class PProgress extends Vue {
  @Prop({ required: true }) totalSize!: number;
  @Prop({ required: true }) progressSize!: number;
  get porcentage(): number {
    if (this.totalSize && this.totalSize > 0 && this.progressSize > 0) {
      const porcent = (this.progressSize * 100) / this.totalSize;
      return porcent >= 100 ? 100 : Math.trunc(porcent);
    } else {
      return 0;
    }
  }
}
export default PProgress;
</script>
<style scoped>
.container_PProgress,
.textProgress_PProgress {
  height: 30px;
}

.container_PProgress {
  position: relative;
  width: 100%;
  background-color: #ccc;
  border: 1px solid rgb(155, 153, 153);
}
.textProgress_PProgress {
  display: flex;
  position: absolute;
  width: 100%;
  z-index: 1;
  align-items: center;
  justify-content: space-around;
}
.progress_PProgress {
  text-align: center;
  background-color: #ffd102;
  border-right: 1px solid rgb(155, 153, 153);
  height: 28px; /**quitamos 2 px del borde del container */
}
</style>
